import { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../config/firebaseConfig";
import { hasPermission } from "../utils/roleAccess";

export default function RoleProtectedRoute({ permission, children }) {
  const [accessState, setAccessState] = useState("checking");

  useEffect(() => {
    const auth = getAuth();
    let isMounted = true;

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        if (isMounted) setAccessState("signed-out");
        return;
      }

      try {
        const userSnapshot = await getDoc(doc(db, "users", user.uid));
        const isAllowed =
          userSnapshot.exists() && hasPermission(userSnapshot.data(), permission);
        if (isMounted) setAccessState(isAllowed ? "allowed" : "denied");
      } catch (error) {
        console.error("Unable to verify screen permission:", error);
        if (isMounted) setAccessState("denied");
      }
    });

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, [permission]);

  if (accessState === "checking") {
    return <div className="p-10 text-center text-gray-600">Checking access...</div>;
  }

  if (accessState !== "allowed") {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <p className="text-center text-gray-600">
          You do not have permission to access this page.
        </p>
      </div>
    );
  }

  return children;
}
